import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FaLock, FaLockOpen, FaPencilAlt } from 'react-icons/fa';

/**
 * Resolve o status normalizado do prontuário a partir dos campos GRAVADO/situacao.
 *
 * @param {object} prontuario
 * @returns {'DEFINITIVO' | 'PARCIAL' | 'RASCUNHO'}
 */
export function resolveStatusProntuario(prontuario) {
  if (!prontuario) return 'RASCUNHO';

  const gravado = String(prontuario.GRAVADO || '')
    .trim()
    .toUpperCase();
  const situacao = String(prontuario.situacao || prontuario.SITUACAO || '')
    .trim()
    .toUpperCase();

  if (gravado === 'SIM' || situacao === 'DEFINITIVO') return 'DEFINITIVO';
  if (gravado === 'NAO' || gravado === '' || situacao === 'PARCIAL') return 'PARCIAL';
  return 'RASCUNHO';
}

const STATUS_CONFIG = {
  DEFINITIVO: {
    label: 'DEFINITIVO',
    Icon: FaLock,
    color: '#198754',
    bg: '#d1e7dd',
    border: '#198754',
    tooltipPrefix: 'Prontuário Gravado Definitivamente',
  },
  PARCIAL: {
    label: 'PARCIAL',
    Icon: FaLockOpen,
    color: '#fd7e14',
    bg: '#fff3cd',
    border: '#fd7e14',
    tooltipPrefix: 'Prontuário Gravado Parcialmente (rascunho)',
  },
  RASCUNHO: {
    label: 'EM PREENCHIMENTO',
    Icon: FaPencilAlt,
    color: '#6c757d',
    bg: '#f8f9fa',
    border: '#adb5bd',
    tooltipPrefix: 'Prontuário ainda não salvo',
  },
};

/**
 * Badge visual de status do prontuário com tooltip explicativo.
 *
 * @param {object}  props
 * @param {'DEFINITIVO'|'PARCIAL'|'RASCUNHO'} props.status  - Status normalizado
 * @param {string}  [props.dataGravacao]  - Data/hora para exibir no tooltip
 * @param {'sm'|'md'}  [props.size]       - Tamanho do badge (sm = sidebar, md = cabeçalho)
 */
export default function StatusProntuarioBadge({ status = 'RASCUNHO', dataGravacao, size = 'md' }) {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.RASCUNHO;
  const { label, Icon, color, bg, border, tooltipPrefix } = config;

  const tooltipText = dataGravacao ? `${tooltipPrefix} em ${dataGravacao}` : tooltipPrefix;

  const isSm = size === 'sm';

  const badgeStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: isSm ? '3px' : '5px',
    padding: isSm ? '2px 6px' : '4px 10px',
    borderRadius: '999px',
    border: `2px solid ${border}`,
    backgroundColor: bg,
    color,
    fontSize: isSm ? '0.75rem' : '0.95rem',
    fontWeight: 700,
    letterSpacing: '0.03em',
    whiteSpace: 'nowrap',
    cursor: 'default',
    userSelect: 'none',
    lineHeight: 1.4,
  };

  return (
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip id={`tooltip-status-${status}`}>{tooltipText}</Tooltip>}
    >
      <span style={badgeStyle} aria-label={tooltipText}>
        <Icon size={isSm ? 9 : 18} aria-hidden="true" />
        {label}
      </span>
    </OverlayTrigger>
  );
}
